import { useTranslation } from '@wix/form-fields';
import React from 'react';
export const StepTitleA11y = ({ index = 0, total = 0, }) => {
    const { t } = useTranslation();
    const stepTitleA11y = t('form.a11y.step.index.title', {
        index: index + 1,
        total,
    });
    return total > 1 ? (React.createElement("span", { "aria-label": stepTitleA11y, "aria-live": "polite" })) : null;
};
//# sourceMappingURL=step-title-a11y.js.map